import { formatMoney as _formatMoney } from './util';

export default function trackProductDetailPage (product) {
    var event = {
        event: 'product-detail-page',
        ecommerce: {
            currencyCode: window.Shopify.currency.active || undefined,
            detail: {
                products: [
                    {
                        name: product.title,
                        id: product.id.toString(),
                        price: _formatMoney(product.price),
                        brand: product.vendor,
                        category: product.type || undefined,
                        variant: product.variant.title.toString(),
                        // product 'price type'
                        dimension15: (
                            product.variant.compare_at_price &&
                            (product.variant.compare_at_price > product.variant.price)
                        )
                            ? 'sale'
                            : 'msrp',
                        // msrp
                        metric2: _formatMoney(product.variant.compare_at_price || product.variant.price),
                    },
                ],
            },
        },
    };

    window.dataLayer.push(event);
}